import HttpService from './commons/HttpService';

const StripeSubscriptionService = {
  createSessionForPlan(stripePlanId, enterpriseUpgrade, maxNumberOfUsers) {
    return HttpService.post('/stripeSubscriptions/session', {
      stripePlanId,
      enterpriseUpgrade,
      maxNumberOfUsers,
    });
  },

  activateSubscription(sessionId) {
    return HttpService.post('/stripeSubscriptions/activate', { sessionId });
  },

  activateSubscriptionUpgrade(sessionId) {
    return HttpService.post('/stripeSubscriptions/activateUpgrade', { sessionId });
  },

  getPlan() {
    return HttpService.get('/stripeSubscriptions/plans');
  },

  getPlansForUpgradeByNumberOfUsers(numberOfUsers) {
    return HttpService.get('/stripeSubscriptions/plansForUpgradeByNumberOfUsers', {
      params: { numberOfUsers },
    });
  },

  getCustomerPortalLink() {
    return HttpService.get('/stripeSubscriptions/customerPortal');
  },

  getUserCurrentMobilePlanInfo() {
    return HttpService.get('/stripeSubscriptions/userCurrentMobilePlanInfo');
  },
};
export default StripeSubscriptionService;
